function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12,
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.584 11.45a.55.55 0 110 1.1H12.55v5.034a.55.55 0 11-1.1 0V12.55H6.415a.55.55 0 110-1.1h5.035V6.415a.55.55 0 111.1 0v5.035h5.034z",
  fill: "#fff"
});

function SvgCircleAddFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iMTIiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTcuNTg0NSAxMS40NDk5QzE3Ljg4ODMgMTEuNDQ5OSAxOC4xMzQ1IDExLjY5NjEgMTguMTM0NSAxMS45OTk5QzE4LjEzNDUgMTIuMzAzNiAxNy44ODgzIDEyLjU0OTkgMTcuNTg0NSAxMi41NDk5TDEyLjU0OTkgMTIuNTQ5OUwxMi41NDk5IDE3LjU4NDVDMTIuNTQ5OSAxNy44ODgzIDEyLjMwMzcgMTguMTM0NSAxMS45OTk5IDE4LjEzNDVDMTEuNjk2MiAxOC4xMzQ1IDExLjQ0OTkgMTcuODg4MyAxMS40NDk5IDE3LjU4NDVMMTEuNDQ5OSAxMi41NDk4TDYuNDE1MjMgMTIuNTQ5OEM2LjExMTQ3IDEyLjU0OTggNS44NjUyMyAxMi4zMDM2IDUuODY1MjMgMTEuOTk5OEM1Ljg2NTI0IDExLjY5NjEgNi4xMTE0OCAxMS40NDk4IDYuNDE1MjQgMTEuNDQ5OEwxMS40NDk5IDExLjQ0OThMMTEuNDQ5OSA2LjQxNTI0QzExLjQ0OTkgNi4xMTE0OCAxMS42OTYxIDUuODY1MjQgMTEuOTk5OSA1Ljg2NTIzQzEyLjMwMzYgNS44NjUyMyAxMi41NDk5IDYuMTExNDcgMTIuNTQ5OSA2LjQxNTIzTDEyLjU0OTkgMTEuNDQ5OUwxNy41ODQ1IDExLjQ0OTlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgCircleAddFilled as ReactComponent };